import { useRouter } from 'next/router';
import { Col, Row, Typography } from '@ag1/ui';
import Link from 'next/link';
import { EduHubSettingsResult } from 'types/studio/eduHub';
import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage/StudioHotspotImage';
import { routes } from '@portal/constants/routes';
import styles from './EduFeaturedArticle.module.scss';

type Props = Pick<EduHubSettingsResult, 'featuredArticle'>;

export const EduFeaturedArticle = ({ featuredArticle }: Props) => {
  const { asPath } = useRouter();
  const { eduHubPost } = routes;

  return (
    <Row className={styles.root}>
      {featuredArticle?.slug && featuredArticle?.coverImage && (
        <Link
          as={eduHubPost({ slug: featuredArticle?.slug.current })}
          href={{
            pathname: eduHubPost({ slug: featuredArticle?.slug.current }),
            query: { backLink: asPath }
          }}
          className={styles.link}>
          <Col>
            <StudioHotspotImageV2
              className={styles.imageCont}
              image={featuredArticle?.coverImage}
              eagerLoading
            />
            <div className={styles.content}>
              <Typography
                variant="headlineSans"
                component="h3"
                size="3"
                noPadding
                className={styles.headline}>
                {featuredArticle?.headline}
              </Typography>
              <Typography variant="body" size="3" className={styles.category} noPadding>
                {featuredArticle?.category?.title}
              </Typography>
            </div>
          </Col>
        </Link>
      )}
    </Row>
  );
};
